module.exports = __webpack_public_path__ + "assets/images/standbyCloseIcon.8b1da.png";